/**
 * GradientText Component
 * Renders text with a gradient color effect
 */

import './gradient-text.css';

export interface GradientTextProps {
  text: string;
  gradient: string;
  className?: string;
}

export function GradientText({ text, gradient, className = '' }: GradientTextProps) {
  return (
    <span
      className={`gradient-text ${className}`}
      style={{
        backgroundImage: gradient,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        color: 'transparent',
      } as React.CSSProperties}
    >
      {text}
    </span>
  );
}
